export const VIRTUAL_FOLDER_ID = '-1';
